import { render, staticRenderFns } from "./CardCampaignPopup.vue?vue&type=template&id=6ded1008&scoped=true"
import script from "./CardCampaignPopup.vue?vue&type=script&lang=js"
export * from "./CardCampaignPopup.vue?vue&type=script&lang=js"
import style0 from "./CardCampaignPopup.vue?vue&type=style&index=0&id=6ded1008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded1008",
  null
  
)

export default component.exports